import VueRouter from "vue-router";
import Start from "./pages/Start";
import Confirm from "./pages/Confirm";

export default new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/forms/:id/start',
            name: 'start',
            component: Start
        },
        {
            path: '/forms/:id/start/iframe',
            name: 'start-iframe',
            component: Start
        },
        {
            path: '/forms/:id/confirm',
            name: 'confirm',
            component: Confirm
        }
    ],
})
